module.exports = __webpack_public_path__ + "img/download-android.59ee4392.png";